import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Calculations = lazy(() => import("./Calculations"));

const CALCULATION_ROUTES: RouteObject[] = [
    {
      path: "/private/calculations",
      element: React.createElement(Calculations),
    },
    {
      path: "/private/calculations/:parentModuleOptionTitle", 
      element: React.createElement(Calculations),
    },
];

export default CALCULATION_ROUTES;